var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"Badge"},[_vm._v("\n  "+_vm._s(_vm.value)+"\n  "),(_vm.enableRemove)?_c('i',{on:{"click":function($event){return _vm.onClose(_vm.value)}}},[_vm._v("x")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }